import styled from 'styled-components';

const Label = styled.label`
    font-size: 12px;
    color: ${props => props.isError || props.isValidationMsg ? '#EB0A1E' : '#666666'};

    margin-bottom: ${props => props.isValidationMsg ? '0' : '0.125rem'};
    display: inline-block;
    ${props => props.isError && 'width: 100%;'}
    ${props => props.isError && 'text-align: center;'}
    ${props => props.isValidationMsg && 'float:right;'}
`;

export default Label;
